import { render, staticRenderFns } from "./CustomerMenuMobile.vue?vue&type=template&id=9fb20d38&"
import script from "./CustomerMenuMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerMenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDrawer,QBtn,QList,QItem,QItemSection,QIcon,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDrawer,QBtn,QList,QItem,QItemSection,QIcon,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
